module.exports = __webpack_public_path__ + "img/chart.e70992ec.svg";